import {useEffect, useRef} from 'react';

const arrayEqual = (array1: any[], array2: any[]): boolean => {
  if (array1.length !== array2.length) {
    return false;
  }
  for (let iterator = 0; iterator < array1.length; iterator += 1) {
    if (array1[iterator] !== array2[iterator]) {
      return false;
    }
  }

  return true;
};

type MaybeCleanUpFn = void | (() => void);

/** @deprecated Remove once List is no longer used */
export const useVariableDependencyEffect = (
  callback: () => MaybeCleanUpFn,
  dependencies: any[]
): void => {
  const ref = useRef<any[]>(dependencies);

  if (!arrayEqual(dependencies, ref.current)) {
    ref.current = dependencies;
  }

  // deprectaed so dependency list has not been checked
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [ref.current]);
};
